import { InputAdornment, Input, styled } from '@mui/material';
import React, { useState } from 'react';
import SearchIcon from '@mui/icons-material/Search';


const CustomInput = styled(Input)({
    '&.MuiFilledInput-root': {
    //   backgroundColor: 'cyan', // Change background color
      border: 'none',
      borderBottom: 'none', // Remove the bottom border
      borderRadius: '4px', // Add border radius
      color: 'rgba(227, 227, 227, 1)',
      paddingLeft: '5px',
      outline: 'none',
      '&:hover': {
        borderBottom: 'none', // Remove the bottom border on hover
      },
      '&.Mui-focused': {
        borderBottom: 'none', // Remove the bottom border when focused
      },
    },
});

const Search = (props) => {

    const {
        // value = '',
        onChange = () => {},
        placeholder = 'Seach',
        type = 'text',
        ...rest
    } = props;

    const handleSearchInputChange = (e) => {
        onChange(e.target.value);
    }

    return (
        <>
            <CustomInput
                type={type}
                placeholder={placeholder}
                // value={value}
                onChange={handleSearchInputChange}
                className="text-10 font-poppins text-text-primary w-full px-3 py-1 bg-primary-light-1 rounded-lg focus:outline-none focus:shadow-outline"
                endAdornment={
                    <InputAdornment position="end">
                        <SearchIcon />
                    </InputAdornment>
                }
                // style={{
                //     border: 'none',
                //     borderBottom: 'none', // Remove the bottom border
                //     outline: 'none',
                //     paddingLeft: '5px', // To accommodate the icon
                //     color: 'rgba(227, 227, 227, 1)', // Change text color if needed
                //   }}
                {...rest}
            />
        </>
    )
}

export default Search;